// THIS CODE IS GENERATED. DO NOT MODIFY
/* istanbul ignore next */
(function(angular) {
    'use strict';
    /*jshint sub:true*/
    angular.module('csKeyTotalsV1', ['bmHttpUtils', 'bluemoon.components.session']).service('csKeyTotalsV1',
        ['$http', 'bmHttpUtils', 'AuthenticatedSessionData',
        function($http, bmHttpUtils, authenticatedSessionData) {
            return {
                get: function(params, suppressErrors) {
                    var paramsCopy = angular.copy(params);
                    return authenticatedSessionData.get().then(function(sessionData) {
                        paramsCopy['companyId'] = sessionData.bindings.ApplicationConfiguration.CompanyId;
                        var url = '/api/core/v1/companies/{companyId}/key-totals';
                        url = url.replace(/{companyId}/g, paramsCopy['companyId']);

                        var query = {
                            'clientId': paramsCopy['clientId']
                        };
                        return bmHttpUtils.unwrapAndValidateHttpPromise(null,
                            $http({url: url, method: 'GET', params: query, headers: {} }), suppressErrors);
                    });
                }

            };
        }]);
}(window.angular));
